import React, { useEffect } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Properties,systemConfiguration,includeScripts, includeBootstrapCss, includeBundleBootstrapCss} from '../../CommonImports';
import 'bootstrap/dist/css/bootstrap.min.css';
import './../css/GCandGridCard.css';

function GCandGridCard() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';

    useEffect(() => {
        includeBootstrapCss();
        includeBundleBootstrapCss();
        includeScripts();

        document.addEventListener('DOMContentLoaded', function () {
            if (window.innerWidth >= 992) {
                const sidebar = Offcanvas(document.getElementById(Properties.SIDEBAR_MENU_PROP));
                if (sidebar && sidebar.show) sidebar.show();
            }
        });
    }, []);

    return (
   <div className="row">
    <div className="col-lg-4 col-md-6 mb-4 d-flex justify-content-center">
        <div className="card shadow-sm border-1 h-100 position-relative custom-card">
        
        <div className="position-absolute top-0 end-0 p-2 z-1">
            <a href="#" className="text-muted me-2"><i className="fi-rr-shield-check"></i></a>
            <a href="#" className="text-muted"><i className="fi-rr-bookmark"></i></a>
        </div>

        <div className="text-center mt-3">
            <a href="#" className="d-inline-block mx-auto" style={{ width: '110px', height: '110px', borderRadius: '50%', overflow: 'hidden' }}>
            <img 
                alt="jobhub"  
                src={mediaUrl + "img-candidate.png?" + sasToken} 
                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} 
            />
            </a>
        </div>

        <div className="card-body text-center">
            <h5 className="card-title mb-1">
            <a href="#" className="text-dark text-decoration-none"><strong>Esther Howard</strong></a>
            </h5>
            <p className="text-muted small mb-2">UI/UX Designer</p>

            <div className="mb-3">
            {[...Array(5)].map((_, i) => (
                <img key={i} src={`${mediaUrl}star.svg?${sasToken}`} alt="star" />
            ))}
            <span className="text-muted small ms-2">(5.0)</span>
            </div>

            <div className="d-flex justify-content-center text-muted small mb-3">
            <span><i className="fi-rr-marker me-1"></i>Chicago, US</span>
            <span className="mx-3">|</span>
            <span><i className="fi-rr-briefcase me-1"></i>Software</span>
            </div>

            <div className="mb-3">
            <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Figma</a>
            <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Adobe XD</a>
            <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">PSD</a>
            <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">App</a>
            <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Digital</a>
            </div>

            <a href="#" className="btn btn-outline-primary btn-sm">View Profile</a>
        </div>
        </div>
    </div>

    <div className="col-lg-4 col-md-6 mb-4 d-flex justify-content-center">
    <div className="card shadow-sm border-1 h-100 position-relative custom-card">
      
      <div className="position-absolute top-0 end-0 p-2 z-1">
        <a href="#" className="text-muted me-2"><i className="fi-rr-shield-check"></i></a>
        <a href="#" className="text-muted"><i className="fi-rr-bookmark"></i></a>
      </div>

      <div className="text-center mt-3">
        <a href="#" className="d-inline-block mx-auto" style={{ width: '110px', height: '110px', borderRadius: '50%', overflow: 'hidden' }}>
          <img 
            alt="jobhub"  
             src={mediaUrl + 'img-candidate2.png?' + sasToken}
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} 
          />
        </a>
      </div>

      <div className="card-body text-center">
        <h5 className="card-title mb-1">
          <a href="#" className="text-dark text-decoration-none"><strong>Esther Howard</strong></a>
        </h5>
        <p className="text-muted small mb-2">UI/UX Designer</p>

        <div className="mb-3">
          {[...Array(5)].map((_, i) => (
            <img key={i} src={`${mediaUrl}star.svg?${sasToken}`} alt="star" />
          ))}
          <span className="text-muted small ms-2">(5.0)</span>
        </div>

        <div className="d-flex justify-content-center text-muted small mb-3">
          <span><i className="fi-rr-marker me-1"></i>Chicago, US</span>
          <span className="mx-3">|</span>
          <span><i className="fi-rr-briefcase me-1"></i>Software</span>
        </div>

        <div className="mb-3">
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Figma</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Adobe XD</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">PSD</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">App</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Digital</a>
        </div>

        <a href="#" className="btn btn-outline-primary btn-sm">View Profile</a>
      </div>
    </div>
  </div>

  <div className="col-lg-4 col-md-6 mb-4 d-flex justify-content-center">
    <div className="card shadow-sm border-1 h-100 position-relative custom-card">
      
      <div className="position-absolute top-0 end-0 p-2 z-1">
        <a href="#" className="text-muted me-2"><i className="fi-rr-shield-check"></i></a>
        <a href="#" className="text-muted"><i className="fi-rr-bookmark"></i></a>
      </div>

      <div className="text-center mt-3">
        <a href="#" className="d-inline-block mx-auto" style={{ width: '110px', height: '110px', borderRadius: '50%', overflow: 'hidden' }}>
          <img 
            alt="jobhub"  
           src={mediaUrl + 'img-candidate3.png?' + sasToken}
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} 
          />
        </a>
      </div>

      <div className="card-body text-center">
        <h5 className="card-title mb-1">
          <a href="#" className="text-dark text-decoration-none"><strong>Esther Howard</strong></a>
        </h5>
        <p className="text-muted small mb-2">UI/UX Designer</p>

        <div className="mb-3">
          {[...Array(5)].map((_, i) => (
            <img key={i} src={`${mediaUrl}star.svg?${sasToken}`} alt="star" />
          ))}
          <span className="text-muted small ms-2">(5.0)</span>
        </div>

        <div className="d-flex justify-content-center text-muted small mb-3">
          <span><i className="fi-rr-marker me-1"></i>Chicago, US</span>
          <span className="mx-3">|</span>
          <span><i className="fi-rr-briefcase me-1"></i>Software</span>
        </div>

        <div className="mb-3">
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Figma</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Adobe XD</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">PSD</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">App</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Digital</a>
        </div>

        <a href="#" className="btn btn-outline-primary btn-sm">View Profile</a>
      </div>
    </div>
  </div>
  <div className="col-lg-4 col-md-6 mb-4 d-flex justify-content-center">
    <div className="card shadow-sm border-1 h-100 position-relative custom-card">
      
      <div className="position-absolute top-0 end-0 p-2 z-1">
        <a href="#" className="text-muted me-2"><i className="fi-rr-shield-check"></i></a>
        <a href="#" className="text-muted"><i className="fi-rr-bookmark"></i></a>
      </div>

      <div className="text-center mt-3">
        <a href="#" className="d-inline-block mx-auto" style={{ width: '110px', height: '110px', borderRadius: '50%', overflow: 'hidden' }}>
          <img 
            alt="jobhub"  
            src={mediaUrl + 'img-candidate5.png?' + sasToken} 
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} 
          />
        </a>
      </div>

      <div className="card-body text-center">
        <h5 className="card-title mb-1">
          <a href="#" className="text-dark text-decoration-none"><strong>Esther Howard</strong></a>
        </h5>
        <p className="text-muted small mb-2">UI/UX Designer</p>

        <div className="mb-3">
          {[...Array(5)].map((_, i) => (
            <img key={i} src={`${mediaUrl}star.svg?${sasToken}`} alt="star" />
          ))}
          <span className="text-muted small ms-2">(5.0)</span>
        </div>

        <div className="d-flex justify-content-center text-muted small mb-3">
          <span><i className="fi-rr-marker me-1"></i>Chicago, US</span>
          <span className="mx-3">|</span>
          <span><i className="fi-rr-briefcase me-1"></i>Software</span>
        </div>

        <div className="mb-3">
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Figma</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Adobe XD</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">PSD</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">App</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Digital</a>
        </div>

        <a href="#" className="btn btn-outline-primary btn-sm">View Profile</a>
      </div>
    </div>
  </div>
  <div className="col-lg-4 col-md-6 mb-4 d-flex justify-content-center">
    <div className="card shadow-sm border-1 h-100 position-relative custom-card">
      
      <div className="position-absolute top-0 end-0 p-2 z-1">
        <a href="#" className="text-muted me-2"><i className="fi-rr-shield-check"></i></a>
        <a href="#" className="text-muted"><i className="fi-rr-bookmark"></i></a>
      </div>

      <div className="text-center mt-3">
        <a href="#" className="d-inline-block mx-auto" style={{ width: '110px', height: '110px', borderRadius: '50%', overflow: 'hidden' }}>
          <img 
            alt="jobhub"  
            src={mediaUrl + 'img-candidate4.png?' + sasToken} 
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} 
          />
        </a>
      </div>

      <div className="card-body text-center">
        <h5 className="card-title mb-1">
          <a href="#" className="text-dark text-decoration-none"><strong>Esther Howard</strong></a>
        </h5>
        <p className="text-muted small mb-2">UI/UX Designer</p>

        <div className="mb-3">
          {[...Array(5)].map((_, i) => (
            <img key={i} src={`${mediaUrl}star.svg?${sasToken}`} alt="star" />
          ))}
          <span className="text-muted small ms-2">(5.0)</span>
        </div>

        <div className="d-flex justify-content-center text-muted small mb-3">
          <span><i className="fi-rr-marker me-1"></i>Chicago, US</span>
          <span className="mx-3">|</span>
          <span><i className="fi-rr-briefcase me-1"></i>Software</span>
        </div>

        <div className="mb-3">
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Figma</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Adobe XD</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">PSD</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">App</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Digital</a>
        </div>

        <a href="#" className="btn btn-outline-primary btn-sm">View Profile</a>
      </div>
    </div>
  </div>

  <div className="col-lg-4 col-md-6 mb-4 d-flex justify-content-center">
    <div className="card shadow-sm border-1 h-100 position-relative custom-card">
      
      <div className="position-absolute top-0 end-0 p-2 z-1">
        <a href="#" className="text-muted me-2"><i className="fi-rr-shield-check"></i></a>
        <a href="#" className="text-muted"><i className="fi-rr-bookmark"></i></a>
      </div>

      <div className="text-center mt-3">
        <a href="#" className="d-inline-block mx-auto" style={{ width: '110px', height: '110px', borderRadius: '50%', overflow: 'hidden' }}>
          <img 
            alt="jobhub"  
            src={mediaUrl + 'img-candidate6.png?' + sasToken} 
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} 
          />
        </a>
      </div>

      <div className="card-body text-center">
        <h5 className="card-title mb-1">
          <a href="#" className="text-dark text-decoration-none"><strong>Esther Howard</strong></a>
        </h5>
        <p className="text-muted small mb-2">UI/UX Designer</p>

        <div className="mb-3">
          {[...Array(5)].map((_, i) => (
            <img key={i} src={`${mediaUrl}star.svg?${sasToken}`} alt="star" />
          ))}
          <span className="text-muted small ms-2">(5.0)</span>
        </div>

        <div className="d-flex justify-content-center text-muted small mb-3">
          <span><i className="fi-rr-marker me-1"></i>Chicago, US</span>
          <span className="mx-3">|</span>
          <span><i className="fi-rr-briefcase me-1"></i>Software</span>
        </div>

        <div className="mb-3">
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Figma</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Adobe XD</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">PSD</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">App</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Digital</a>
        </div>

        <a href="#" className="btn btn-outline-primary btn-sm">View Profile</a>
      </div>
    </div>
  </div>

  <div className="col-lg-4 col-md-6 mb-4 d-flex justify-content-center">
    <div className="card shadow-sm border-1 h-100 position-relative custom-card">
      
      <div className="position-absolute top-0 end-0 p-2 z-1">
        <a href="#" className="text-muted me-2"><i className="fi-rr-shield-check"></i></a>
        <a href="#" className="text-muted"><i className="fi-rr-bookmark"></i></a>
      </div>

      <div className="text-center mt-3">
        <a href="#" className="d-inline-block mx-auto" style={{ width: '110px', height: '110px', borderRadius: '50%', overflow: 'hidden' }}>
          <img 
            alt="jobhub"  
            src={mediaUrl + 'img-candidate7.png?' + sasToken}
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} 
          />
        </a>
      </div>

      <div className="card-body text-center">
        <h5 className="card-title mb-1">
          <a href="#" className="text-dark text-decoration-none"><strong>Esther Howard</strong></a>
        </h5>
        <p className="text-muted small mb-2">UI/UX Designer</p>

        <div className="mb-3">
          {[...Array(5)].map((_, i) => (
            <img key={i} src={`${mediaUrl}star.svg?${sasToken}`} alt="star" />
          ))}
          <span className="text-muted small ms-2">(5.0)</span>
        </div>

        <div className="d-flex justify-content-center text-muted small mb-3">
          <span><i className="fi-rr-marker me-1"></i>Chicago, US</span>
          <span className="mx-3">|</span>
          <span><i className="fi-rr-briefcase me-1"></i>Software</span>
        </div>

        <div className="mb-3">
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Figma</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Adobe XD</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">PSD</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">App</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Digital</a>
        </div>

        <a href="#" className="btn btn-outline-primary btn-sm">View Profile</a>
      </div>
    </div>
  </div>

  <div className="col-lg-4 col-md-6 mb-4 d-flex justify-content-center">
    <div className="card shadow-sm border-1 h-100 position-relative custom-card">
      
      <div className="position-absolute top-0 end-0 p-2 z-1">
        <a href="#" className="text-muted me-2"><i className="fi-rr-shield-check"></i></a>
        <a href="#" className="text-muted"><i className="fi-rr-bookmark"></i></a>
      </div>

      <div className="text-center mt-3">
        <a href="#" className="d-inline-block mx-auto" style={{ width: '110px', height: '110px', borderRadius: '50%', overflow: 'hidden' }}>
          <img 
            alt="jobhub"  
            src={mediaUrl + 'img-candidate8.png?' + sasToken} 
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} 
          />
        </a>
      </div>

      <div className="card-body text-center">
        <h5 className="card-title mb-1">
          <a href="#" className="text-dark text-decoration-none"><strong>Esther Howard</strong></a>
        </h5>
        <p className="text-muted small mb-2">UI/UX Designer</p>

        <div className="mb-3">
          {[...Array(5)].map((_, i) => (
            <img key={i} src={`${mediaUrl}star.svg?${sasToken}`} alt="star" />
          ))}
          <span className="text-muted small ms-2">(5.0)</span>
        </div>

        <div className="d-flex justify-content-center text-muted small mb-3">
          <span><i className="fi-rr-marker me-1"></i>Chicago, US</span>
          <span className="mx-3">|</span>
          <span><i className="fi-rr-briefcase me-1"></i>Software</span>
        </div>

        <div className="mb-3">
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Figma</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Adobe XD</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">PSD</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">App</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Digital</a>
        </div>

        <a href="#" className="btn btn-outline-primary btn-sm">View Profile</a>
      </div>
    </div>
  </div>

  <div className="col-lg-4 col-md-6 mb-4 d-flex justify-content-center">
    <div className="card shadow-sm border-1 h-100 position-relative custom-card">
      
      <div className="position-absolute top-0 end-0 p-2 z-1">
        <a href="#" className="text-muted me-2"><i className="fi-rr-shield-check"></i></a>
        <a href="#" className="text-muted"><i className="fi-rr-bookmark"></i></a>
      </div>

      <div className="text-center mt-3">
        <a href="#" className="d-inline-block mx-auto" style={{ width: '110px', height: '110px', borderRadius: '50%', overflow: 'hidden' }}>
          <img 
            alt="jobhub"  
            src={mediaUrl + 'img-candidate9.png?' + sasToken} 
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} 
          />
        </a>
      </div>

      <div className="card-body text-center">
        <h5 className="card-title mb-1">
          <a href="#" className="text-dark text-decoration-none"><strong>Esther Howard</strong></a>
        </h5>
        <p className="text-muted small mb-2">UI/UX Designer</p>

        <div className="mb-3">
          {[...Array(5)].map((_, i) => (
            <img key={i} src={`${mediaUrl}star.svg?${sasToken}`} alt="star" />
          ))}
          <span className="text-muted small ms-2">(5.0)</span>
        </div>

        <div className="d-flex justify-content-center text-muted small mb-3">
          <span><i className="fi-rr-marker me-1"></i>Chicago, US</span>
          <span className="mx-3">|</span>
          <span><i className="fi-rr-briefcase me-1"></i>Software</span>
        </div>

        <div className="mb-3">
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Figma</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Adobe XD</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">PSD</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">App</a>
          <a href="#" className="btn btn-sm btn-outline-secondary me-1 mb-1">Digital</a>
        </div>

        <a href="#" className="btn btn-outline-primary btn-sm">View Profile</a>
      </div>
    </div>
  </div>
  
</div>

    );
}

export default GCandGridCard;
